module.exports = __webpack_public_path__ + "static/media/btn_sputnik.8ab855d7.png";